import {} from "./platform";
export default function resolveWebPlatformOs() {
    if (typeof navigator === "undefined") {
        return "DESKTOP";
    }
    const userAgent = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const maxTouchPoints = typeof navigator.maxTouchPoints === "number" ? navigator.maxTouchPoints : 0;
    const isIosDevice = /iPhone|iPad|iPod/i.test(userAgent) || /iPhone|iPad|iPod/i.test(platform) || (platform === "MacIntel" && maxTouchPoints > 1);
    if (isIosDevice) {
        return "IOS";
    }
    if (/Android/i.test(userAgent)) {
        return "ANDROID";
    }
    return "DESKTOP";
}
